import { CancelToken } from 'axios'

/*
  axios cancel token 中心
  eg.
    axios.get(url, {
      params,
      ...cancelPending.getCancelToken('xxx')
    })

    cancelPending.cancel('xxx')
*/
export const cancelPending = {
  data: {},
  // 更新 pending 列表
  update(key, token) {
    this.data[key] = token
  },
  // 取消指定 axios 请求
  cancel(key) {
    const cancel = this.data[key]
    cancel && cancel()
  },
  // 批量取消指定 axios 请求
  cancelSome(keylist = []) {
    keylist.forEach((key) => {
      this.cancel(key)
    })
  },
  getCancelToken(key) {
    return {
      cancelToken: new CancelToken((c) => {
        this.update(key, c)
      })
    }
  }
}
